module.exports = __webpack_public_path__ + "10b9e1c6cb9a7aff20337d3670205861.svg";